import axios from '../utils/axios';

class UsersService {
  constructor() {
    this.BaseUrl = '/users';
  }
  get() {
    return axios.get(this.BaseUrl);
  }
}

export default new UsersService();
